import { site } from '../config';
import CallButton from './CallButton';
import ChatButton from './ChatButton';

export default function HelpBand({ title = 'Still stuck? Let’s fix it together.' }) {
  return (
    <section className="help-band">
      <div className="wrap help-band-row">
        <div>
          <h2>{title}</h2>
          <p>Chat or call {site.phone} — a support agent is available right now.</p>
        </div>
        <div className="btn-row">
          <ChatButton variant="white" />
          <CallButton variant="ghost-light" />
        </div>
      </div>
    </section>
  );
}
